<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section v-menu-permission="'list'" class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           :entity="modelName"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryPackageMaterialResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table ref="emTable"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      :entity="modelName" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">

                                <template #left-header>
                                    <em-button :disabled="actionDisabled('select')"
                                               :showName="true"
                                               custom-label="手动检验"
                                               type="search"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="unpackingVisible = true"
                                    >
                                    </em-button>
                                    <em-button :disabled="false" :showName="true" class="btn-size"
                                               custom-icon="fa fa-fw fa-lg fa-check"
                                               custom-label="扫码检验"
                                               type="edit"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openCheckDialog()"
                                    >
                                    </em-button>
                                    <em-button :disabled="false" :showName="true" class="btn-size"
                                               custom-icon="fa fa-fw fa-lg fa-check"
                                               custom-label="扫描箱码"
                                               type="edit"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openMatScanner()"
                                    >
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog :center="true" :close-on-click-modal='false' :visible.sync="matScannerVisible" append-to-body
                   title="扫一扫" @close="closeMatScannerDialog">
            <qr-code-scanner ref="matScanner" @getCodeData='getPackageInfo'>
            </qr-code-scanner>
        </el-dialog>

        <el-dialog :close-on-click-modal='false' :visible.sync="checkDialogVisible" append-to-body title="扫码检验"
                   width="55%"
                   @close='clearMaterialList'>
            <el-table :data="materialList" empty-text="暂无数据" max-height="300px" style="width:100%">
                <el-table-column label="项目号" prop="projectCode" width="130"></el-table-column>
                <el-table-column label="发货码" prop="deliveryCode" width="130"></el-table-column>
                <el-table-column label="数量" prop="quantity" width="60"></el-table-column>
                <el-table-column label="单位" prop="unit" width="50"></el-table-column>
                <el-table-column label="物料号" prop="materialCode" width="150"></el-table-column>
                <el-table-column label="转交物料中文描述" prop="materialDesc" width="200"></el-table-column>
                <el-table-column label="CID" prop="cid" width="50"></el-table-column>
            </el-table>

            <el-form ref="checkByScanForm" :model="checkByScanForm" :rules="checkByScanRule" label-width="auto">
                <el-form-item label="账实是否相符" prop="accountMatchActualSituationOrNot">
                    <el-radio-group v-model="checkByScanForm.accountMatchActualSituationOrNot1">
                        <el-radio :label=true>是</el-radio>
                        <el-radio :label=false>否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="账实不符原因" prop="notMatchReason">
                    <el-input v-model="checkByScanForm.notMatchReason1" type="textarea"></el-input>
                </el-form-item>
            </el-form>
            <el-dialog :center="true" :close-on-click-modal='false' :visible.sync="openScanner" append-to-body
                       title="扫一扫" @close="closeScannerDialog">
                <qr-code-scanner ref="checkScanner" @getCodeData='getCodeData'>
                </qr-code-scanner>
            </el-dialog>
            <div slot="footer" class="dialog-footer">
                <el-button @click="openScannerDialog()">扫码识别</el-button>
                <el-button @click="checkDialogVisible = false">取消</el-button>
                <el-button :disabled="materialList.length == 0" type="primary"
                           @click="checkByScan()">确认
                </el-button>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal='false' :visible.sync="unpackingVisible" append-to-body title="手动检验"
                   width="55%"
                   @close='clearUnpacking'>
            <el-form ref="unpackingForm" :model="unpackingForm" :rules="unpackingRule" label-width="auto">
                <el-form-item label="账实是否相符" prop="accountMatchActualSituationOrNot">
                    <el-radio-group v-model="unpackingForm.accountMatchActualSituationOrNot">
                        <el-radio :label=true>是</el-radio>
                        <el-radio :label=false>否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="账实不符原因" prop="notMatchReason">
                    <el-input v-model="unpackingForm.notMatchReason" type="textarea"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="unpackingVisible = false">取消</el-button>
                <el-button type="primary" @click="manualCheck()">确认</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
// Author Lin
// Date 2021-06-28 10:31:33

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";
import commonViewsUtil from "@/utils/commonViewsUtil";

export default {
    name: "sithMesInventoryUnpackingListView",
    components: {qrCodeScanner},
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonApiMixin, commonViewsUtil],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        },
        $_emCustomVuexMixin_vo: {
            type: String,
            default: 'unpackingVo'
        },
        $_emCustomVuexMixin_filter: {
            type: String,
            default: 'unpackingFilter'
        },
    },
    data() {
        return {
            matScannerVisible: false,
            checkDialogVisible: false,
            materialList: [],
            checkByScanForm: {
                accountMatchActualSituationOrNot1: true,
                notMatchReason1: '',
            },
            onComplete: false,
            unpackingVisible: false,
            unpackingForm: {
                accountMatchActualSituationOrNot: true,
                notMatchReason: ''
            },
            unpackingRule: {
                accountMatchActualSituationOrNot: [{required: true, message: '请选择是否相符.'}]
            },
            checkByScanRule: {
                accountMatchActualSituationOrNot1: [{required: true, message: '请选择是否相符.'}]
            },
            openScanner: false,
        }
    },
    computed: {
        modelName() {
            return 'sithMesInventoryPackageMaterial'
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItemsUnpackingVo"];
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItemsUnpackingVo"].join(",");
        },
    },
    methods: {
        initFilter() {
            // BIND(1, "绑定"),
            // UNBIND(0, "已解绑");
            let bindingState = 1;
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('bindingStateFilter', bindingState);
            this.$refs['emListFilter'].doQuery();
        },

        getPackageInfo(data) {
            console.log("get qr code data:" + data);
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var packageId = obj['packageId'];
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            this.matScannerVisible = false;
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('packageIdFilter', packageId);
            this.$refs['emListFilter'].doQuery();
        },
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },

        openCheckDialog() {
            this.checkDialogVisible = true;
        },
        openMatScanner() {
            this.matScannerVisible = true;
            setTimeout(() => {
                this.$refs.matScanner.openCamera('');
            }, 500);
        },
        closeScannerDialog() {
            this.$refs.checkScanner.closeCamera();
            this.$refs.checkScanner.resetOutputData();
            this.openScanner = false;
        },
        closeMatScannerDialog() {
            this.$refs.matScanner.closeCamera();
            this.$refs.matScanner.resetOutputData();
            this.matScannerVisible = false;
        },

        openScannerDialog() {
            this.openScanner = true;
            setTimeout(() => {
                this.$refs.checkScanner.openCamera('');
            }, 500);
        },

        clearMaterialList() {
            this.materialList = [];
            this.checkByScanForm.accountMatchActualSituationOrNot1 = '';
            this.checkByScanForm.notMatchReason1 = ''
        },

        clearUnpacking() {
            this.unpackingForm.accountMatchActualSituationOrNot = '';
            this.unpackingForm.notMatchReason = ''
        },

        manualCheck() {
            let self = this;
            self.$refs["unpackingForm"].validate(valid => {
                if (valid) {
                    if (!self.unpackingForm.accountMatchActualSituationOrNot && self.unpackingForm.notMatchReason === '') {
                        self.$message({
                            message: "账实不符，请填写原因！",
                            type: "error",
                        });
                        return;
                    }

                    let url = `${this.$_emApiMixin_entityBaseApi(
                            "sithMesInventoryPackageMaterial")}/manualCheck?ids=${this.selectIds}&accountMatchActualSituationOrNot=${self.unpackingForm.accountMatchActualSituationOrNot}&notMatchReason=${self.unpackingForm.notMatchReason}`
                    self.$_emApiMixin_post(url, {})
                            .then(response => {
                                if (response.status === 200) {
                                    self.$message({
                                        message: "检验完成！",
                                        type: "success",
                                    });

                                    self.$refs.emListFilter.doQuery();
                                } else {
                                    self.$message({
                                        message: "检验失败！",
                                        type: "error",
                                    });
                                }
                            })
                            .finally(() => this.unpackingVisible = false)
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            })
        },

        //扫码检验
        checkByScan() {
            let self = this;
            self.$refs["checkByScanForm"].validate(valid => {
                if (valid) {

                    if (!self.checkByScanForm.accountMatchActualSituationOrNot1 && self.checkByScanForm.notMatchReason1 === '') {
                        self.$message({
                            message: "账实不符，请填写原因！",
                            type: "error",
                        });
                        return;
                    }

                    let url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryPackageMaterial")}/checkPackageMaterial`;
                    self.materialList[0].accountMatchActualSituationOrNot = self.checkByScanForm.accountMatchActualSituationOrNot1;
                    self.materialList[0].notMatchReason = self.checkByScanForm.notMatchReason1;
                    self.$_emApiMixin_post(url, self.materialList[0])
                            .then(response => {
                                if (response.status === 200) {
                                    self.$message({
                                        message: "检验完成！",
                                        type: "success",
                                    });

                                    self.$refs.emListFilter.doQuery();
                                } else {
                                    self.$message({
                                        message: "检验失败！",
                                        type: "error",
                                    });
                                }
                            })
                            .finally(() => this.checkDialogVisible = false)
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            })
        },

        getCodeData(data) {
            console.log("get qr code data:" + data);
            this.openScanner = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var deliveryCode = obj['发货码'];
            } catch (error) {
                self.$message({
                    message: "无效的二维码！",
                    type: "error",
                });
                return;
            }

            if (deliveryCode === '') {
                self.$message({
                    message: "二维码中缺少发货码！",
                    type: "error",
                });
                self.openScanner = false;
                return;
            }

            let _url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryPackageMaterial")}/`;
            _url += `findMaterialByDeliveryCode?deliveryCode=${deliveryCode}`;
            self.$_emApiMixin_get(_url, {})
                    .then((value) => {
                        var arr = Object.keys(value);
                        if (arr.length != 0) {
                            console.log("value ====== " + JSON.stringify(value));
                            self.materialList = [];
                            self.materialList.push(value);
                            self.$message({
                                message: "扫码成功",
                                type: "success",
                            });
                        } else {
                            self.$message({
                                message: "无对应物料或物料已开箱检验！",
                                type: "error",
                            });
                        }
                    })
                    .finally(() => {
                        this.openScanner = false;
                    });
        },
    },
    mounted() {
        this.$refs["emListFilter"].doQuery();
        this.$store.state.commonList.customVuexName = "unpacking";
        this.initFilter();
    }
};
</script>
